const SvgPaginaWeb: React.FC<{ className?: string, height?: number, width?: number }> = ({ className, height, width }) => (
    <svg
        className={`h-10 w-10 ${className}`}
        width={width}
        height={height}
        viewBox="2 0 20 24"
        stroke-width="1.5"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <path
            stroke="none"
            d="M0 0h24v24H0z"
        />
        <circle
            cx="12" cy="12" r="9"
        />
        <line
            x1="3.6"
            y1="9"
            x2="20.4"
            y2="9"
        />
        <line
            x1="3.6"
            y1="15"
            x2="20.4"
            y2="15"
        />
        <path
            d="M11.5 3a17 17 0 0 0 0 18"
        />
        <path
            d="M12.5 3a17 17 0 0 1 0 18"
        />

    </svg>

);

export default SvgPaginaWeb;